// extracted by mini-css-extract-plugin
export var cardHeader = "_go-0";
export var reorderHandle = "_go-3";
export var titleArea = "_go-1";
export var titleAreaWithHandle = "_go-2";